<h1 class="mt-5">Configuración de ponderación</h1>

<!-- DESCARGA DE INFORMACIÓN -->
<div class="row mt-5 align-items-center">
  <div class="hr-amarillo mr-3"></div>
  <h6 class="mb-0">Descarga de información</h6>
  <button class="btn">
    <i (click)="toggleDescargaInfo()" [ngClass]="!mostrarDescargaInfo ? 'bi-plus-circle' : 'bi-dash-circle'" class="bi tamanio_iconos-boton"></i>
  </button>
</div>

<div class="descarga-info" *ngIf="mostrarDescargaInfo">
  <div class="alert alert-success tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeDescargaExito">
    <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{mensajeDescargaExito}}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-success">&times;</span>
    </button>
  </div>

  <div class="alert alert-danger tipografía_alertas mt-4 mb-4 collapse show  animate__fadeIn" role="alert" *ngIf="errorDescarga" id="collapseWidthExample">
    <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ errorDescarga }}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-danger">&times;</span>
    </button>
  </div>

  <div class="row mt-3">
    <div class="col-2">
      <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label><label
        class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
      <select class="form-control select_criterios" [(ngModel)]="anyoSeleccionado.descarga"
      (ngModelChange)="obtenerListaPeriodos(anyoSeleccionado.descarga,'descarga');resetearValidacion()"
      [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyoDescarga'] }" required>
        <option selected hidden value="0">Seleccionar</option>
        <option [value]="anyo" *ngFor="let anyo of listaAnyos">{{anyo}}</option>
      </select>
      <div *ngIf="submitted && tieneErrores['anyoDescarga']" class="invalid-feedback">
        <div *ngIf="tieneErrores['anyoDescarga']">Campo requerido</div>
      </div>
    </div>
    <div class="col-3">
      <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label><label
        class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
      <select class="form-control select_criterios" [(ngModel)]="periodoSeleccionado.descarga" (ngModelChange)="resetearValidacion()"
      [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodoDescarga'] }" required>
        <option value="0" hidden selected>Seleccionar</option>
        <option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of listaPeriodos.descarga">{{periodo.periodoDescripcion}}</option>
      </select>
      <div *ngIf="submitted && tieneErrores['periodoDescarga']" class="invalid-feedback">
        <div *ngIf="tieneErrores['periodoDescarga']">Campo requerido</div>
      </div>
    </div>
    <div class="col-4">
      <button class="boton-secundario mt-4" data-toggle="tooltip" data-placement="top" title="DESCARGAR"
        alt="DESCARGAR"(click)="descargarPonderacion()">DESCARGAR
      </button>
    </div>
  </div>
  <!-- FIN DESCARGA DE INFORMACIÓN -->
</div>


<!-- INGRESO DE ARCHIVO -->
<form >
  <div class="row mt-5">
    <div class="hr-amarillo mr-3"></div>
    <h6 class="mb-0">Ingreso de archivo</h6>
  </div>
  <div class="alert alert-success  tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeExito">
    <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{mensajeExito}}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-success">&times;</span>
    </button>
  </div>
  <div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="error">
    <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ error }}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-danger">&times;</span>
    </button>
  </div>
  <div class="row mt-4">
    <div class="col-1" style="margin-top:8px; padding-right:4px !important;">
      <label class="titulo_criterios" style="margin-bottom:9px"  for="exampleFormControlSelect2">Año</label>
      <select name="anho" class="form-control select_criterios" [(ngModel)]="anyoSeleccionado.carga"
      (ngModelChange)="obtenerListaPeriodos(anyoSeleccionado.carga,'carga');resetearValidacion()"
      [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyoCarga'] }">
        <option value="0" selected hidden>Seleccionar</option>
        <option *ngFor="let anyo of listaAnyos" [value]="anyo">{{anyo}}</option>
      </select>
      <div *ngIf="submitted && tieneErrores['anyoCarga']" class="invalid-feedback">
        <div *ngIf="tieneErrores['anyoCarga']">Campo req...</div>
      </div>
    </div>
    <div class="col-2" style="margin-top:8px">
      <label class="titulo_criterios" style="margin-bottom:9px" for="exampleFormControlSelect2">Periodo</label>
      <select name="periodo" class="form-control select_criterios" [(ngModel)]="periodoSeleccionado.carga"  (ngModelChange)="resetearValidacion()"
      [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodoCarga'] }">
        <option value="0" hidden selected>Seleccionar</option>
        <option *ngFor="let periodo of listaPeriodos.carga" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
      </select>
      <div *ngIf="submitted && tieneErrores['periodoCarga']" class="invalid-feedback">
        <div *ngIf="tieneErrores['periodoCarga']">Campo req...</div>
      </div>
    </div>
    <div class="col-4" >
      <label class="titulo_criterios" style="display: initial;" for="exampleFormControlSelect2">Cargar archivo ( peso
        máx: 10mb /
        <button class="btn py-0" data-toggle="tooltip" data-placement="top" title="Descargar archivo ejemplo"
          alt="Descargar archivo ejemplo" type="button" (click)="descargarEjemplo();">
          <i class="bi bi-filetype-xlsx icono-tabla"></i>
        </button> 
        )  </label>
      <div class="custom-file">
        <input [id]="'file-0'" class="d-none" (change)="onFileChanged($event, 0);resetearValidacion()" onclick="this.value=null;" type="file" class="custom-file-input"
        [ngClass]="{ 'is-invalid': submitted && tieneErrores['archivoCarga'] }" required>
        <label class="custom-file-label select_criterios mb-0" for="validatedCustomFile">{{textoCargaArchivo}}
        </label>
        <div *ngIf="submitted && tieneErrores['archivoCarga']" class="invalid-feedback">
          <div *ngIf="tieneErrores['archivoCarga']">Campo requerido</div>
        </div>
      </div>
    </div>
    <div class="col-5 d-flex justify-content-center">
      <button class="boton-primario mt-5" data-toggle="tooltip" data-placement="top" title="PROCESAR" alt="PROCESAR" (click)="cargarArchivo();">PROCESAR
      </button>
      <button type="button" class="boton-secundario tamanio_iconos-boton mt-5 ml-1" data-toggle="tooltip" data-placement="top" title="LIMPIAR"
        alt="LIMPIAR" (click)="limpiarCargaArchivo();resetearValidacion()">
        <i class="bi bi-x"></i>
      </button>
      <button class="boton-copiar mt-5 ml-3" data-toggle="modal" data-target="#modalCopiar" data-placement="top" title="COPIAR"
        alt="COPIAR" type="button">
        <i class="bi bi-files"></i> COPIAR
      </button>
    </div>
  </div>
</form>

<!-- FIN INGRESO DE ARCHIVO -->

<!-- TABLA -->
<div style="margin-top: 40px;">
  <table *ngIf="!renderTableListaArchivos" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla ponderacion masiva">
    <thead class="header_tabla">
      <tr>
        <th>Id Proceso</th>
        <th>Año</th>
        <th>Periodo</th>
        <th>Registros OK</th>
        <th>Registros Error</th>
        <th>Estado de carga</th>
        <th>Log de errores</th>
        <th>Fecha de carga</th>
        <th>Usuario de carga</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td ></td>
        <td ></td>
        <td ></td>
        <td ></td>
        <td ></td>
        <td style="width: 100%">
          Procesando...
        </td>
        <td ></td>
        <td ></td>
        <td ></td>
      </tr>
    </tbody>
  </table>
  <table id="tabla-ponderacion" *ngIf="renderTableListaArchivos" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla ponderacion masiva">
    <thead class="header_tabla">
      <tr>
        <th>Id Proceso</th>
        <th>Año</th>
        <th>Periodo</th>
        <th>Registros OK</th>
        <th>Registros Error</th>
        <th>Estado de carga</th>
        <th>Log de errores</th>
        <th>Fecha de carga</th>
        <th>Usuario de carga</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let archivo of listaArchivos.archivos; index as ind">
        <td class="py-0">
          <p class="celda">{{ archivo.archivoPonderacionId }}</p>
        </td>
        <td class="py-0">
          <p class="celda">{{ archivo.anoAcademico }}</p>
        </td>
        <td class="py-0">
          <p class="celda">{{ archivo.periodoDescripcion }}</p>
        </td>
        <td class="py-0">
          <p class="celda">{{ archivo.nroRegOk }}</p>
        </td>
        <td class="py-0">
          <p class="celda">{{ archivo.nroRegError }}</p>
        </td>
        <td class="py-0">
          <p class="celda">
            <span class="badge badge-pill finalizado d-flex justify-content-center py-2" *ngIf="archivo.estado == 'F'">Finalizado</span>
            <span class="badge badge-pill en_proceso d-flex justify-content-center py-2" *ngIf="archivo.estado == 'EP'">En proceso</span>
            <span class="badge badge-pill error d-flex justify-content-center py-2" *ngIf="archivo.estado == 'ER'">Error</span>
          </p>
        </td>
        <td class="d-flex justify-content-center py-1">
          <p class="celda">
            <button type="button" (click)="descargarLogs(ind)" class="btn py-0"  *ngIf="archivo.nroRegError !== 0" data-toggle="tooltip" data-placement="top" title="DESCARGAR LOG DE ERRORES" alt="DESCARGAR LOG DE ERRORES">
              <i class="bi bi-filetype-xlsx icono-tabla"></i>
            </button>
            <i class="bi bi-dash" *ngIf="archivo.nroRegError == 0"></i>
          </p>
        </td>
        <td class="py-0">
          <p class="celda">{{ archivo.fechaCreacion }}</p>
        </td>
        <td class="py-0">
          <p class="celda">{{ archivo.usuarioCreacion }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- FIN TABLA -->




<!-- MODAL COPIAR -->
<div class="modal fade" id="modalCopiar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Copia de configuración</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR" (click)="limpiarSelects();resetearValidacion()">
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <form>
      <div class="modal-body">
          <div class="row align-items-center my-3 mx-4">
            <div class="hr-amarillo ml-4"></div>
            <p class="mb-0 ml-3">Origen</p>
          </div>
          <div class="row mt-3 mx-4 my-4">
            <div class="col-6">
              <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
              <select class="form-control select_criterios" [(ngModel)]="anyoSeleccionado.copiarOrigen"
              (ngModelChange)="obtenerListaPeriodos(anyoSeleccionado.copiarOrigen,'copiarOrigen'); resetearValidacion()" name="anyoOrigen"
              [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyoOrigen'] }" required>
                <option selected hidden value="0">Seleccionar</option>
                <option [value]="anyo" *ngFor="let anyo of listaAnyos">{{anyo}}</option>
              </select>
              <div *ngIf="submitted && tieneErrores['anyoOrigen']" class="invalid-feedback">
                <div *ngIf="tieneErrores['anyoOrigen']">Campo requerido</div>
              </div>
            </div>
            <div class="col-6">
              <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
              <select class="form-control select_criterios" [(ngModel)]="periodoSeleccionado.copiarOrigen" (ngModelChange)="resetearValidacion()" name="periodoOrigen"
              [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodoOrigen'] }" required>
                <option value="0" hidden selected>Seleccionar</option>
                <option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of listaPeriodos.copiarOrigen">{{periodo.codigoPeriodo}}</option>
              </select>
              <div *ngIf="submitted && tieneErrores['periodoOrigen']" class="invalid-feedback">
                <div *ngIf="tieneErrores['periodoOrigen']">Campo requerido</div>
              </div>
            </div>
          </div>
          <div class="row align-items-center my-3 mx-4">
            <div class="hr-amarillo ml-4"></div>
            <p class="mb-0 ml-3">Destino</p>
          </div>
          <div class="row mt-3 my-4 mx-4">
            <div class="col-6">
              <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
              <select class="form-control select_criterios" [(ngModel)]="anyoSeleccionado.copiarDestino"
              (ngModelChange)="obtenerListaPeriodos(anyoSeleccionado.copiarDestino,'copiarDestino'); resetearValidacion()" name="anyoDestino"
              [ngClass]="{ 'is-invalid': submitted && tieneErrores['anyoDestino'] }" required>
                <option selected hidden value="0">Seleccionar</option>
                <option [value]="anyo" *ngFor="let anyo of listaAnyos">{{anyo}}</option>
              </select>
              <div *ngIf="submitted && tieneErrores['anyoDestino']" class="invalid-feedback">
                <div *ngIf="tieneErrores['anyoDestino']">Campo requerido</div>
              </div>
            </div>
            <div class="col-6">
              <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
              <select class="form-control select_criterios" [(ngModel)]="periodoSeleccionado.copiarDestino" (ngModelChange)="resetearValidacion()" name="periodoDestino"
              [ngClass]="{ 'is-invalid': submitted && tieneErrores['periodoDestino'] }" required>
                <option value="0" hidden selected>Seleccionar</option>
                <option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of listaPeriodos.copiarDestino">{{periodo.codigoPeriodo}}</option>
              </select>
              <div *ngIf="submitted && tieneErrores['periodoDestino']" class="invalid-feedback">
                <div *ngIf="tieneErrores['periodoDestino']">Campo requerido</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="errorCopia">
                <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{errorCopia}}
                <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
                  <span aria-hidden="true" class="alert-danger">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button hidden id="btn-copiar" type="body" class="boton-primario my-3 justify-content-center" data-toggle="tooltip" data-placement="top"
          title="COPIAR" alt="COPIAR" data-dismiss="modal">COPIAR
        </button>
        <button type="button" class="boton-primario my-3 justify-content-center" data-toggle="tooltip" data-placement="top"
          title="COPIAR" alt="COPIAR" (click)="validarCopia()">COPIAR
        </button>
      </div>
    </form>
    </div>
  </div>
</div>
<!-- FIN MODAL COPIAR -->